import axios, { AxiosError } from "axios"
import { LIST_PATH, TAX_PATH } from "../../constants/paths"
import {
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials,
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
} from "interceptors"

const instance = axios.create({
  baseURL: process.env.REACT_APP_CONFIGURATION_API_SERVICE_DOMAIN,
})

instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)
export const getTaxesService = async () => {
  try {
    const result = await instance.get(TAX_PATH + LIST_PATH)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const createTaxesService = async (tax: any) => {
  console.log(tax)
  try {
    const result = await instance.post(TAX_PATH, tax)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const deleteTaxService = async (id: any) => {
  try {
    const result = await instance.delete(TAX_PATH + `/${id}`)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const editTaxService = async (id: number, office: any) => {
  try {
    const result = await instance.put(TAX_PATH + `/${id}`, office)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}
